import { NextSeo } from "next-seo";

import CalcCtaBand from "@/components/calculators/CalcCtaBand";
import CalculatorCard from "@/components/calculators/CalculatorCard";
import { HubHero } from "@/components/marketing/HubGrid";
import Breadcrumbs from "@/components/seo/Breadcrumbs";
import JsonLd from "@/components/seo/JsonLd";
import Footer from "@/components/shared/Footer";
import { CALCULATORS } from "@/lib/calculators/data";
import { breadcrumbsForPath } from "@/lib/seo/breadcrumbs";
import { hubGraph } from "@/lib/seo/graph";
import { HUBS } from "@/lib/seo/pages";

const PATH = HUBS.calculator.path;

const SEO_TITLE = "Free Calculators for Content Creators | Crayo";
const SEO_DESCRIPTION =
  "Free calculators for short-form creators. See how many views you need to make money, how many posts to hit a million, and what your views are worth.";

export default function CalculatorsHub() {
  const crumbs = breadcrumbsForPath(PATH);

  return (
    <>
      <NextSeo title={SEO_TITLE} description={SEO_DESCRIPTION} />
      <JsonLd
        nodes={hubGraph({
          path: PATH,
          name: "Run the numbers on your content",
          description: SEO_DESCRIPTION,
          items: CALCULATORS.map((calculator) => ({
            name: calculator.cardTitle,
            url: `/calculators/${calculator.slug}`,
            description: calculator.description,
          })),
        })}
      />

      <article className="w-full overflow-x-clip bg-white">
        <Breadcrumbs items={crumbs} />
        <HubHero
          title="Run the numbers on your content"
          intro="Free, no-signup calculators for clippers and short-form creators. See what your views are worth, how much you need to post, and how far one long video can take you."
        />

        <section>
          <div className="mx-auto w-full max-w-screen-xl px-5 py-12 sm:px-6 md:px-12 md:py-16 lg:px-20 lg:py-20">
            <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3">
              {CALCULATORS.map((calculator) => (
                <li key={calculator.slug}>
                  <CalculatorCard calculator={calculator} />
                </li>
              ))}
            </ul>
          </div>
        </section>

        <CalcCtaBand />
      </article>

      <Footer />
    </>
  );
}
